import { useEffect, useRef } from 'react';

const money = amount => `₹${Number(amount || 0).toFixed(2)}`;
const dateLabel = value => {
  if (!value) return 'Not recorded';
  const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00+05:30` : value);
  return Number.isFinite(date.getTime()) ? date.toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric' }) : value;
};

export default function AccountPaymentHistory({ buyer, onClose }) {
  const close = useRef(null);
  useEffect(() => {
    const previousFocus = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    close.current?.focus();
    const escape = event => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', escape);
    return () => {
      document.body.style.overflow = overflow;
      document.removeEventListener('keydown', escape);
      previousFocus?.focus?.();
    };
  }, [onClose]);
  const orders = buyer.orders || [];
  const receipts = orders.flatMap(order => (order.paymentReceipts || []).map((receipt, index) => ({
    ...receipt, key: `${order._id}:${receipt._id || receipt.requestId || index}`,
    reference: order.orderId || order.MK_order_id || order._id,
  }))).sort((a, b) => String(b.date || b.recordedAt || '').localeCompare(String(a.date || a.recordedAt || '')));
  const received = receipts.reduce((sum, receipt) => sum + Math.round(Number(receipt.amount || 0) * 100), 0) / 100;
  const paid = orders.reduce((sum, order) => sum + Math.round(Number(order.paidAmount || 0) * 100), 0) / 100;
  return <div className="fixed inset-0 z-[210] flex items-center justify-center bg-black/50 p-4">
    <section role="dialog" aria-modal="true" aria-label={`Payment history for ${buyer.name}`} className="max-h-[90vh] w-full max-w-5xl overflow-auto rounded-xl bg-white p-5 shadow-xl">
      <div className="mb-4 flex items-center justify-between gap-3"><h3 className="text-xl font-bold">Payment history · {buyer.name}</h3><button ref={close} type="button" onClick={onClose} className="rounded border px-4 py-2">Close</button></div>
      <p className="mb-3 text-sm">{receipts.length} recorded payments · Receipt total: <strong>{money(received)}</strong></p>
      {Math.abs(paid - received) > 0.005 && <p className="mb-3 text-sm text-amber-800">Account paid amount: {money(paid)}. Some payments do not have an itemized receipt in these entries.</p>}
      {receipts.length ? <div className="overflow-x-auto"><table className="w-full text-left text-sm"><thead><tr>{['Payment date', 'Amount', 'Method', 'Recorded by', 'Recorded on', 'Reference', 'Notes'].map(title => <th key={title} className="border-b p-2">{title}</th>)}</tr></thead>
        <tbody>{receipts.map(receipt => <tr key={receipt.key}><td className="border-b p-2 whitespace-nowrap">{dateLabel(receipt.date)}</td><td className="border-b p-2 font-semibold">{money(receipt.amount)}</td><td className="border-b p-2">{receipt.method || 'Not recorded'}</td><td className="border-b p-2">{receipt.recordedBy || 'Not recorded'}</td><td className="border-b p-2 whitespace-nowrap">{dateLabel(receipt.recordedAt)}</td><td className="border-b p-2">{receipt.reference}</td><td className="border-b p-2">{receipt.notes || '—'}</td></tr>)}</tbody>
      </table></div> : <p className="py-6 text-gray-500">No itemized payment receipts recorded for these entries.</p>}
    </section>
  </div>;
}
